<template>
  <div v-if="loading"></div>
  <div v-else class="setting-channels">
    <div class="setting-channels__mode">
      <p>Режим настройки</p>
      <InputRadio :value="'simple'" :modelValue="activeSetting" :name="'setting'" @change="changeSetting('simple')"
        >Простой</InputRadio
      >
      <InputRadio :value="'advanced'" :modelValue="activeSetting" :name="'setting'" @change="changeSetting('advanced')"
        >Расширенный</InputRadio
      >
    </div>

    <div v-if="typeSettingNotify" class="setting-channels__simple">
      <p>Каналы получения</p>
      <SimpleCheckbox
        v-for="(type, index) in settingNotify.channels_types"
        :key="index"
        :checked="settingNotify.settings.find((item) => item.channel_name === type)?.is_working"
        @change="changeSimple(type, !settingNotify.settings.find((item) => item.channel_name === type)?.is_working)"
        >{{ type }}</SimpleCheckbox
      >
    </div>

    <div
      v-else
      class="setting-channels__advanced"
      :style="` grid-template-columns: 520px repeat(${
        settingNotify?.channels_types && settingNotify.channels_types.length
      }, 1fr);`"
    >
      <template class="row-table">
        <div class="row-table__name" />
        <div v-for="name in settingNotify.channels_types" :key="name" class="row-table__cell">
          {{ name }}
        </div>
      </template>
      <template v-for="item in settingNotify.settings" class="row-table">
        <div :key="item.section_id" class="row-table__name" @click="clickActiveRow(item.section_name)">
          <AppIcon
            src="@icons/arrow-open.svg"
            class="arrow-block"
            :class="{ 'arrow-block_active': activeRow.includes(item.section_name) }"
          />
          {{ item.section_name }}
        </div>

        <SwitchInput
          v-for="(type, index) in settingNotify.channels_types"
          :key="item.section_id + index"
          class="row-table__cell"
          :checked="!item.notifications.filter((notifiy) => !notifiy.channels.includes(type)).length"
          @change="
            changeChannelsList({
              id: item.section_id,
              type: type,
              value: item.notifications.filter((item) => !item.channels.includes(type)).length,
            })
          "
        />

        <template v-if="activeRow.includes(item.section_name) && !!item.section_name.length">
          <template v-for="childItem in item.notifications">
            <div class="row-table__name row-table__name-child">{{ childItem.notification_name }}</div>
            <SwitchInput
              v-for="(type, index) in settingNotify.channels_types"
              :key="index"
              class="row-table__cell"
              :checked="childItem.channels.includes(type)"
              @change="
                changeChannelsItem({
                  section_id: item.section_id,
                  id: childItem.notification_id,
                  type: type,
                  value: !childItem.channels.includes(type),
                })
              "
            />
          </template>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import InputRadio from "@/components/common/InputRadio.vue";
import SimpleCheckbox from "@/components/common/SimpleCheckbox.vue";
import SwitchInput from "@/components/common/SwitchInput.vue";
import AppIcon from "@/components/common/Icon.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    InputRadio,
    AppIcon,
    SimpleCheckbox,
    SwitchInput,
  },

  data: () => ({
    activeRow: [],
    loading: false,
  }),

  computed: {
    ...mapGetters({
      orgId: "Organizations/ActiveOne/getId",
      activeUserId: "User/getUserId",
      settingNotify: "User/Settings/getSettingNotify",
      typeSettingNotify: "User/Settings/getTypeSettingNotify",
    }),

    activeSetting() {
      return this.typeSettingNotify ? "simple" : "advanced";
    },
  },

  mounted() {
    this.loading = true;
    this.getSettingNotify({ orgId: this.orgId, user_id: this.activeUserId }).finally(() => (this.loading = false));
  },

  methods: {
    ...mapActions({
      getSettingNotify: "User/Settings/getSettingNotify",
      changeSettingNotify: "User/Settings/changeSettingNotify",
      changSetupNotify: "User/Settings/changSetupNotify",
    }),

    clickActiveRow(value) {
      if (this.activeRow.includes(value)) {
        this.activeRow = this.activeRow.filter((item) => item !== value);
      } else {
        this.activeRow.push(value);
      }
    },

    checkedIn(item) {
      return !item.notifications.filter((notifiy) => notifiy.channels.filter((channel) => !channel.is_working)).length;
    },

    changeSimple(type, value) {
      this.changSetupNotify({
        orgId: this.orgId,
        user_id: this.activeUserId,
        settings: [
          {
            channel_id: type,
            is_working: value,
          },
        ],
      }).finally(() => this.getSettingNotify({ orgId: this.orgId, user_id: this.activeUserId }));
    },

    changeSetting(value) {
      this.changeSettingNotify({
        orgId: this.orgId,
        user_id: this.activeUserId,
        simple_settings: value === "simple",
      });
    },

    changeChannelsItem({ id, type, value }) {
      this.changSetupNotify({
        orgId: this.orgId,
        user_id: this.activeUserId,
        settings: [
          {
            channel_id: type,
            notification_id: id,
            is_working: value,
            // section_id: section_id,
          },
        ],
      }).finally(() => this.getSettingNotify({ orgId: this.orgId, user_id: this.activeUserId }));
    },
    changeChannelsList({ id, type, value }) {
      this.changSetupNotify({
        orgId: this.orgId,
        user_id: this.activeUserId,
        settings: [
          {
            channel_id: type,
            section_id: id,
            is_working: value,
          },
        ],
      }).finally(() => this.getSettingNotify({ orgId: this.orgId, user_id: this.activeUserId }));
    },
  },
};
</script>

<style scoped lang="scss">
.setting-channels {
  &__mode {
    margin-bottom: 32px;

    p {
      margin-bottom: 32px;
      color: #555;
      font-size: 14px;
    }

    ::v-deep .input-radio {
      margin-bottom: 12px;
    }

    &:last-child {
      margin-top: 12px;
    }
  }

  &__simple {
    p {
      margin-bottom: 32px;
      color: #555;
      font-size: 14px;
    }

    ::v-deep .checkbox {
      margin-bottom: 12px;
    }
  }

  &__advanced {
    margin-top: 30px;

    display: grid;
    width: 870px;
    justify-items: center;
    gap: 16px 16px;
  }
}

.row-table {
  &__name {
    font-size: 14px;
    font-weight: 700;
    justify-self: start;

    ::v-deep .icon {
      cursor: pointer;
      margin-right: 16px;
      //transform: rotate(180deg);
    }

    &-child {
      font-weight: 400;
      padding-left: 32px;
    }
  }

  &__cell {
    padding: 8px 15px;
  }
}

.arrow-block {
  transition: 300ms;
  transform: rotate(180deg);
  &_active {
    transform: rotate(0);
  }
}
</style>
